import React from "react";
import { AutoDialerV2 } from "@td/auto_dialer";
import { useAutoDialer } from "../utils";
import { VIEW_STATES } from "../constants/call-status";
import UnknownViewState from "./UnknownViewState";
import CallInProgress from "./CallInProgress";
import UnavailableMember from "./UnavailableMember";

const {
  CallComplete,
  DialingMember,
  DialingProvider,
  JoinViaPhone,
  StartCall
} = AutoDialerV2;

const WebRTC = () => {
  const {
    memberName,
    viewState,
    hasActiveCall,
    callStatus,
    device,
    beginCall,
    restartCall,
  } = useAutoDialer();

  const renderViewState = () => {
    switch (viewState) {
      case VIEW_STATES.UNKNOWN:
        return (
          <UnknownViewState />
        );
      case VIEW_STATES.START_CALL:
        return (
          <StartCall
            isReady={device && !hasActiveCall}
            onClick={beginCall}
          />
        );
      case VIEW_STATES.DIALING_MEMBER:
        return (
          <DialingMember />
        );
      case VIEW_STATES.UNAVAILABLE:
        return (
          <UnavailableMember />
        );
      case VIEW_STATES.DIALING_PROVIDER:
        return (
          <DialingProvider
            memberName={memberName}
          />
        );
      case VIEW_STATES.CALL_IN_PROGRESS:
      case VIEW_STATES.PROVIDER_REJOIN:
        return (
          <CallInProgress />
        );
      case VIEW_STATES.CALL_COMPLETE:
        return (
          <CallComplete
            callStatus={callStatus}
            onClick={restartCall}
          />
        );
      case VIEW_STATES.JOIN_VIA_PHONE:
        return (
          <JoinViaPhone />
        );
      default:
        return null;
    }
  };

  return (
    <div className="auto-dialer-container">
      {renderViewState()}
    </div>
  );
};

WebRTC.displayName = "WebRTC";

export default WebRTC;
